import type {TimeZone} from 'timezones-list';
import timezones from 'timezones-list';
import {doesContainKeywords} from '@Components/event-wizard/event-wizard.helper';
import {getShortTzCodeText, getTzCodeText} from '@Components/event-wizard/timezone-content/timezone-content.helper';

export const filterTimeZones = (keywords: string): Array<TimeZone> => {
  if (keywords === '') {
    return timezones;
  }
  return timezones.filter((timezone) => {
    return doesContainKeywords(`${getTzCodeText(timezone.tzCode)} ${getShortTzCodeText(timezone.tzCode)}`, keywords);
  });
};
